import {useQuery} from "@tanstack/react-query"
import {disbursementService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {Disbursement} from "types/fin-aid/disbursement"

const INITIAL_DATA: Disbursement[] = []

export const useStudentDisbursements = (studentProfileId: number) => {
    const query = useQuery(
        ["student-disbursements", studentProfileId],
        async () => {
            const {data} = await disbursementService.list({
                filter: {
                    studentProfileId
                },
                range: {
                    limit: UNLIMITED_PAGE_SIZE,
                    offset: 0
                }
            })
            return data
        },
        {
            refetchOnMount: false
        }
    )
    return {data: query.data ?? INITIAL_DATA}
}
